import {FC, Suspense, useEffect} from "react";
import {Navigate, Route, Routes} from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import {getCSSVariableValue} from "../../_metronic/assets/ts/_utils";
import {WithChildren} from "../../_metronic/helpers";
import {MasterLayout} from "../../_metronic/layout/MasterLayout";
import {adminPages} from "../mock/pages";
import {URL_MAIN} from "../mock/page_urls";
import {useBrowserNotification} from "../hooks/useBrowserNotification";
import {createChatWebSocket} from "../utils/createChatWebSocket";

const AdminRoutes = () => {
  const {showBrowserNotification} = useBrowserNotification();

  useEffect(() => {
    // @ts-ignore
    const {socket} = createChatWebSocket(showBrowserNotification);

    return () => {
      socket.close();
    };
  }, [showBrowserNotification]);
  return (
      <Routes>
        <Route element={<MasterLayout/>}>
          <Route path="auth/*" element={<Navigate to={URL_MAIN}/>}/>
          {adminPages.map((page) => (
              <Route
                  key={page.path}
                  path={page.path}
                  element={
                    <SuspensedView>
                      <page.component/>
                    </SuspensedView>
                  }
              />
          ))}
          <Route path="*" element={<Navigate to="/error/404"/>}/>
        </Route>
      </Routes>
  );
};

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue("--bs-primary");
  TopBarProgress.config({
    barColors: {
      "0": baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  });
  return <Suspense fallback={<TopBarProgress/>}>{children}</Suspense>;
};

export {AdminRoutes};
